import React, { useState, useEffect } from 'react';
import { supabaseAdmin } from '../../lib/supabaseAdmin';

const ArticlesList = ({ onEdit, onNew }) => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);

    const fetchArticles = async () => {
        try {
            const { data, error } = await supabaseAdmin
                .from('articles')
                .select('id, title, slug, is_featured, published_at, category:categories(name)')
                .order('created_at', { ascending: false });

            if (error) throw error;
            setArticles(data || []);
        } catch (error) {
            console.error('Error fetching articles:', error);
            setStatus({ type: 'error', message: 'Failed to load articles' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchArticles();
    }, []);

    const handleDelete = async (id, title) => {
        if (!window.confirm(`Are you sure you want to delete "${title}"?`)) return;

        try {
            const { error } = await supabaseAdmin
                .from('articles')
                .delete()
                .eq('id', id);

            if (error) throw error;
            setStatus({ type: 'success', message: `"${title}" deleted successfully` });
            fetchArticles();
        } catch (error) {
            console.error('Error deleting article:', error);
            setStatus({ type: 'error', message: 'Failed to delete article' });
        }
    };

    if (loading) return <div className="empty-state"><p>Loading articles...</p></div>;

    return (
        <div className="articles-list">
            <div className="articles-list-header">
                <h2>Articles</h2>
                <button className="btn-primary" onClick={onNew}>+ New Article</button>
            </div>

            {status && (
                <div className={`admin-status ${status.type}`}>{status.message}</div>
            )}

            {articles.length === 0 ? (
                <div className="empty-state">
                    <p>No articles yet. Create your first one!</p>
                    <button className="btn-primary" onClick={onNew}>Create Article</button>
                </div>
            ) : (
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Category</th>
                            <th>Published</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {articles.map((article) => (
                            <tr key={article.id}>
                                <td>{article.title}</td>
                                <td>{article.category?.name || '—'}</td>
                                <td>
                                    {article.published_at
                                        ? new Date(article.published_at).toLocaleDateString()
                                        : '—'}
                                </td>
                                <td>
                                    {article.is_featured && <span className="badge badge-featured">Featured</span>}
                                    {!article.published_at && <span className="badge badge-draft">Draft</span>}
                                </td>
                                <td className="actions">
                                    <button className="btn-secondary" onClick={() => onEdit(article.id)}>Edit</button>
                                    <button className="btn-danger" onClick={() => handleDelete(article.id, article.title)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ArticlesList;
